import { APP_CONFIG, getHeaders } from "../constants/global-variables.js";

export async function changePassword(
  data = { oldPassword, newPassword, newPasswordRepeat }
) {
  const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/changepassword`;

  try {
    const res = await axios.post(url, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        "Content-Type": "application/json",
      },
    });

    return res.data;
  } catch (err) {
    console.log("Error getting documents");
  }
}

export async function userData(userId) {
  const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/childrenuserdata`;

  try {
    const res = await axios.post(
      url,
      {
        user: userId,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data.data;
  } catch (err) {
    console.log("Error getting documents");
  }
}

export async function updateUserData(data) {
  const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/updateuserinfo`;

  try {
    const res = await axios.post(url, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        "Content-Type": "application/json",
      },
    });

    return res.data;
  } catch (err) {
    console.log("Error getting documents");
  }
}

export async function moneyTransfer(data = { user, amount, currency }) {
  const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/moneytransfer`;

  try {
    const res = await axios.post(url, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        "Content-Type": "application/json",
      },
    });

    return res.data;
  } catch (err) {
    console.log("Error getting documents");
  }
}

export async function accountBalance(start_date, end_date, currency) {
  let role = localStorage.getItem("role");
  const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/accountbalanceof${role}`;

  try {
    const res = await axios.post(
      url,
      {
        start_date,
        end_date,currency,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data.data;
  } catch (err) {
    console.log("Error getting documents");
  }
}

export async function accountBalanceForChildren(
  start_date,
  end_date,
  agent_id,
  currency
) {
  let role = localStorage.getItem("role");
  let url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/accountbalanceof`;
  if (role == "Supermanager") {
    url += "Manager";
  }

  if (role == "Manager") {
    url += "Agent";
  }

  try {
    const res = await axios.post(
      url,
      {
        start_date,
        end_date,
        children_id: agent_id,currency,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data.data;
  } catch (err) {
    console.log("Error getting documents");
  }
}



export async function casinoBalance(start_date, end_date, currency) {
  let role = localStorage.getItem("role");
  const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/casinobalanceof${role}`;

  try {
    const res = await axios.post(
      url,
      {
        start_date,
        end_date, currency,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data.data;
  } catch (err) {
    console.log("Error getting documents");
  }
}

export async function casinoBalanceForChildren(
  start_date,
  end_date,
  agent_id, currency
) {

  let role = localStorage.getItem("role");
  let url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/casinobalanceof`;
  if (role == "Supermanager") {
    url += "Manager";
  }

  if (role == "Manager") {
    url += "Agent";
  }


  try {
    const res = await axios.post(
      url,
      {
        start_date,
        end_date,
        children_id: agent_id, currency,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data.data;
  } catch (err) {
    console.log("Error getting documents");
  }
}


export async function gsCasinoBalance(start_date, end_date, currency) {
    let role = localStorage.getItem("role");
    if(role == 'User') role = 'user'
    const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/gscasinobalanceof${role}`;

    try {
        const res = await axios.post(
            url,
            {
                start_date,
                end_date, currency,
            },
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    "Content-Type": "application/json",
                },
            }
        );

        return res.data.data;
    } catch (err) {
        console.log("Error getting documents");
    }
}

export async function gsCasinoBalanceForChildren(
    start_date,
    end_date,
    agent_id, currency
) {

    let role = localStorage.getItem("role");
    let url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/gscasinobalanceof`;
    if (role == "Supermanager") {
        url += "Manager";
    }

    if (role == "Manager") {
        url += "Agent";
    }


    try {
        const res = await axios.post(
            url,
            {
                start_date,
                end_date,
                children_id: agent_id, currency,
            },
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    "Content-Type": "application/json",
                },
            }
        );

        return res.data.data;
    } catch (err) {
        console.log("Error getting documents");
    }
}

export async function virtualBalance(start_date, end_date, currency) {
  let role = localStorage.getItem("role");
  const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/virtualbalanceof${role}`;

  try {
    const res = await axios.post(
      url,
      {
        start_date,
        end_date, currency,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data.data;
  } catch (err) {
    console.log("Error getting documents");
  }
}

export async function virtualBalanceForChildren(
  start_date,
  end_date,
  agent_id, currency
) {

  let role = localStorage.getItem("role");
  let url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/virtualbalanceof`;
  if (role == "Supermanager") {
    url += "Manager";
  }

  if (role == "Manager") {
    url += "Agent";
  }



  try {
    const res = await axios.post(
      url,
      {
        start_date,
        end_date,
        children_id: agent_id, currency,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data.data;
  } catch (err) {
    console.log("Error getting documents");
  }
}

export async function allBalance(start_date, end_date, currency) {
  let role = localStorage.getItem("role");
  const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/allbalanceof${role}`;

  try {
    const res = await axios.post(
      url,
      {
        start_date,
        end_date, currency,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data.data;
  } catch (err) {
    console.log("Error getting documents");
  }
}

export async function allBalanceForChildren(
  start_date,
  end_date,
  agent_id, currency
) {

  let role = localStorage.getItem("role");
  let url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/allbalanceof`;
  if (role == "Supermanager") {
    url += "Manager";
  }

  if (role == "Manager") {
    url += "Agent";
  }


  try {
    const res = await axios.post(
      url,
      {
        start_date,
        end_date,
        children_id: agent_id, currency,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data.data;
  } catch (err) {
    console.log("Error getting documents");
  }
}

// export async function accountBalance(start_date,end_date, agentId) {
//   let role = localStorage.getItem('role');
//   const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/accountbalanceof${role}`;
//
//   try {
//     const res = await axios.post(
//         url,
//         {
//           start_date,
//           end_date,
//           children_id: agentId,
//         },
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("access_token")}`,
//             "Content-Type": "application/json",
//           },
//         }
//     );
//
//     return res.data.data;
//   } catch (err) {
//     console.log("Error getting documents");
//   }
// }

export async function getTransactions(startDate, endDate, currency, for_user) {
  const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/transactions`;

  try {
    const res = await axios.post(
      url,
      {
        start_date: startDate,
        end_date: endDate,
        currency,
        for_user: !for_user || for_user == '' ? null : for_user
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data;
  } catch (err) {
    console.log("Error getting documents");
  }
}

export async function smFinance(children_id, startDate, endDate, currency) {
  const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/allbalanceofmanagerpercentage`;

  try {
    const res = await axios.post(
      url,
      {
        children_id,
        start_date: startDate,
        end_date: endDate,
        currency
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data.data;
  } catch (err) {
    console.log("Error getting documents");
  }
}

export async function updateMenagerPercentage(user_id, sport_percentage, virtual_percentage, casino_percentage) {
  const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/updatemenagerpercentage`;

  try {
    const res = await axios.post(
      url,
      {
        user_id,
        sport_percentage,
        virtual_percentage,
        casino_percentage
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data;
  } catch (err) {
    console.log("Error getting documents");
  }
}

export async function updateAgentPercentage(user_id, sport_percentage, virtual_percentage, casino_percentage) {
  const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/updateagentpercentage`;

  try {
    const res = await axios.post(
      url,
      {
        user_id,
        sport_percentage,
        virtual_percentage,
        casino_percentage
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data;
  } catch (err) {
    console.log("Error getting documents");
  }
}

export async function getProfileDetails() {
  const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/profiledetails`;

  try {
    const res = await axios.get(url, {headers: getHeaders()});
    return res.data;
  } catch (e) {}

  return null;
}

export async function allCurrencyAccountBalance(start_date, end_date, children_id) {
  let role = localStorage.getItem("role");
  const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/accountbalanceof${role}allcurrency`;

  try {
    const res = await axios.post(
      url,
      {
        start_date,
        end_date,
        children_id
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data.data;
  } catch (err) {
    console.log("Error getting documents");
  }
}

export async function allCurrencyGSCasinoBalance(start_date, end_date, children_id) {
  let role = localStorage.getItem("role");
  const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/allcurrgscasinobalanceof${role}`;

  try {
    const res = await axios.post(
      url,
      {
        start_date,
        end_date,
        children_id
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data.data;
  } catch (err) {
    console.log("Error getting documents");
  }
}

export async function allCurrencyCasinoBalance(start_date, end_date, children_id) {
  let role = localStorage.getItem("role");
  const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/allcurrcasinobalanceof${role}`;

  try {
    const res = await axios.post(
      url,
      {
        start_date,
        end_date,
        children_id
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data.data;
  } catch (err) {
    console.log("Error getting documents");
  }
}

export async function allCurrencyVirtualBalance(start_date, end_date, children_id) {
  let role = localStorage.getItem("role");
  const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/allcurrvirtualbalanceof${role}`;

  try {
    const res = await axios.post(
      url,
      {
        start_date,
        end_date,
        children_id
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data.data;
  } catch (err) {
    console.log("Error getting documents");
  }
}